module.exports = __webpack_public_path__ + "ax.svg?e939bf2ecb653b16e31928f62f14161b";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/ax.svg
// module id = 1239
// module chunks = 0